<mat-dialog-content>
  <h3>Apply Edits to Multiple Prep Locations</h3>
  @if (edits.length > 0) {
    <div class="edits-section" style="margin-bottom: 1em">
      <div style="font-weight: 500">Edits:</div>
      @for (edit of edits; track edit) {
        <div style="color: #444">{{ edit }}</div>
      }
    </div>
  }
  <multi-prep-checklist
    [(prepLocations)]="prepLocations"
    [currentPrepLocation]="this.dialogInput.prepLocationName"></multi-prep-checklist>
  <div class="button-container">
    <button mat-button color="warn" (click)="onNoClick()">Exit</button>
    <button mat-flat-button color="accent" [mat-dialog-close]="this.prepLocations">Apply</button>
  </div>
</mat-dialog-content>
